import { QueryPagination } from 'components/Table/Pagination'
import type {
  CustomersRequestData,
  CustomersResponseData,
  CustomersResponseDataApi
} from './types'
import api from 'services/api'
import { endpoints } from 'constants/endpoints'

import { toCustomersRequestDataApi, toCustomersResponseData } from './adapters'

export const getCustomers = async (
  body: CustomersRequestData,
  pagination: QueryPagination
): Promise<CustomersResponseData> => {
  const bodyApi = toCustomersRequestDataApi(body)

  const response = await api.post<CustomersResponseDataApi>(
    endpoints.customers,
    bodyApi,
    {
      params: { ...pagination }
    }
  )

  return toCustomersResponseData(response.data)
}
